/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessInvoiceTransactionsRequest
 */
export interface ProcessInvoiceTransactionsRequest {
    /**
     * When true, failed invoice transactions are reset to pending and reprocessed in the same batch.
     * @type {boolean}
     * @memberof ProcessInvoiceTransactionsRequest
     */
    retryFailed?: boolean;
}

/**
 * Check if a given object implements the ProcessInvoiceTransactionsRequest interface.
 */
// @ts-ignore
export function instanceOfProcessInvoiceTransactionsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

// @ts-ignore
export function ProcessInvoiceTransactionsRequestFromJSON(json: any): ProcessInvoiceTransactionsRequest {
    return ProcessInvoiceTransactionsRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function ProcessInvoiceTransactionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessInvoiceTransactionsRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retryFailed': !exists(json, 'retry_failed') ? undefined : json['retry_failed'],
    };
}

// @ts-ignore
export function ProcessInvoiceTransactionsRequestToJSON(value?: ProcessInvoiceTransactionsRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retry_failed': value.retryFailed,
    };
}

